var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remove-step-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('f7-icon',{attrs:{"f7":"trash","size":"14"}}),_c('label',[_vm._v("このSTEPを削除")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }